import {
  MOBILE_MENU_MAX_BREAKPOINT,
  DESKTOP_MENU_MIN_BREAKPOINT,
} from 'modules/nav/constants/breakpoints';
import styled, { css } from 'styled-components';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { DESKTOP_SIDEBAR_WIDTH_VALUE } from './constants';

export const Container = styled.div<{ $navBarOffset: number }>`
  overflow: hidden;
  position: relative;
  padding: 0 ${spacing.layoutLRPadding};
  height: ${({ $navBarOffset }) =>
    `calc(100vh - (${pxToRem($navBarOffset)} + ${spacing.layoutTopPadding} + ${spacing.layoutTopPadding}))`};
  width: 100%;
  display: grid;
  grid-template-columns: ${pxToRem(DESKTOP_SIDEBAR_WIDTH_VALUE)} 1fr;
  grid-template-rows: 100%;
  gap: ${spacing.plusHalf};
  grid-template-areas: "sidebar main";

  @media only screen and (max-width: ${MOBILE_MENU_MAX_BREAKPOINT}) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    grid-template-areas:
      "sidebar"
      "main";
  }
`;

const stickyStyles = css`
  top: 0;
  left: 0;
  position: sticky;
`;

export const Sidebar = styled.div`
  grid-area: sidebar;
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
  z-index: 2;

  @media only screen and (min-width: ${DESKTOP_MENU_MIN_BREAKPOINT}) {
    ${stickyStyles};
    height: 85vh;
  }
`;
